import { render, staticRenderFns } from "./ViolationPerQuestionTable.vue?vue&type=template&id=52db996e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ViolationPerQuestionTable.vue?vue&type=script&lang=js"
export * from "./ViolationPerQuestionTable.vue?vue&type=script&lang=js"
import style0 from "./ViolationPerQuestionTable.vue?vue&type=style&index=0&id=52db996e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db996e",
  null
  
)

export default component.exports